import React from 'react';

const MobailApp = () => {
    return (
        <div>
            <h1> Comeing soon </h1>
            
        </div>
    );
};

export default MobailApp;